import { render, staticRenderFns } from "./OldRuleBidOptions.vue?vue&type=template&id=6aeac83b"
import script from "./OldRuleBidOptions.vue?vue&type=script&lang=js"
export * from "./OldRuleBidOptions.vue?vue&type=script&lang=js"
import style0 from "./OldRuleBidOptions.vue?vue&type=style&index=0&id=6aeac83b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports